import { HttpClient, httpResource } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { DashboardStats } from '../models/dashboard-stats';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DashboardStatsService {
  baseUrl: string = environment.api_url;

  readonly refreshTrigger = signal(0);

  stats = httpResource<DashboardStats>(() => {
    // Cette fonction est réactive : 
    // Si refreshTrigger change, la requête est re-exécutée.
    this.refreshTrigger();
    return `${this.baseUrl}/stats`;
  });

  constructor() { }

  refresh() {
    this.refreshTrigger.update(v => v + 1);
  }
}
